export class ContextFactory {
  static renderingContextFor(canvas: HTMLCanvasElement): CanvasRenderingContext2D {
    const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d')
    if (ctx == null) {
      throw new Error('Unable to get rendering context')
    }
    return ctx
  }
}
